const NETWORK_ERROR_PATTERNS = [
  "load failed",
  "failed to fetch",
  "networkerror",
  "network error",
  "network request failed",
  "internet connection appears to be offline",
  "the network connection was lost",
  "could not connect to the server",
  "connection lost",
  "connection closed",
  "server timeout elapsed",
  "websocket",
  "failed to start the transport",
  "failed to complete negotiation",
  "failed to negotiate",
];

export const CONNECTION_ERROR_MESSAGE =
  "Connection problem. Please check your internet connection and try again.";

export function getRawErrorMessage(error: unknown): string {
  if (!error) {
    return "";
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error === "object") {
    const anyError = error as any;

    return (
      anyError?.error ||
      anyError?.message ||
      anyError?.response?.data?.error ||
      anyError?.response?.data?.message ||
      anyError?.data?.error ||
      anyError?.data?.message ||
      ""
    );
  }

  return "";
}

export function isLikelyConnectionError(error: unknown): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return true;
  }

  const message = getRawErrorMessage(error).toLowerCase();

  if (!message) {
    return false;
  }

  return NETWORK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

export function getUserFacingErrorMessage(
  error: unknown,
  fallbackMessage: string,
): string {
  if (isLikelyConnectionError(error)) {
    return CONNECTION_ERROR_MESSAGE;
  }

  return getRawErrorMessage(error) || fallbackMessage;
}
